import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
}

const UploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
}) => {
  const settingsApplied = getWatermarkTag(image) !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
      showText={!!hasText}
      showPreview={false}
      aspectRatio={1080 / 790}
      imgRatioX={108}
      imgRatioY={79}
      textDebounceDelay={300}
    />
  );
};

export default memo(UploadedImageRow);
